<template>
  <div>
    <v-icon v-if="!is_login">favorite</v-icon>
    <v-btn v-if="is_login" flat icon @click="favorite" color="#FF47ED">
      <v-icon v-if="isFavorite">favorite</v-icon>
      <v-icon v-else>favorite_border</v-icon>
    </v-btn>
    {{ heart_count }}
    <error-message ref="errorDialog" />
  </div>
</template>

<script>
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    ErrorMessage
  },
  props: {
    heart: {
      type: Number,
      default: 0
    },
    graphId: {
      type: Number,
      default: 0
    },
    is_login: {
      type: Boolean,
      default: false
    },
    is_favorite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getFavorite() {
      return this.is_favorite;
    }
  },
  watch: {
    heart: function() {
      this.heart_count = this.heart;
    },
    getFavorite() {
      this.setFavorite();
    }
  },
  data() {
    return {
      heart_count: this.heart,
      isFavorite: false
    };
  },
  methods: {
    setFavorite() {
      this.isFavorite = this.is_favorite;
    },
    favorite() {
      const apiUrl = "/v1/graphs/favorite/" + this.graphId;
      this.$http
        .put(
          apiUrl,
          {
            params: {
              id: this.graphId
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.login.auth_token
            }
          }
        )
        .then(res => {
          this.heart_count = res.data.heart_count;
          if (this.isFavorite) {
            this.isFavorite = false;
          } else {
            this.isFavorite = true;
          }
        })
        .catch(error => {
          this.graphList = [];
          this.$refs.errorDialog.setMessage(
            "いいねの更新に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    }
  },
  created() {
    this.isFavorite = this.is_favorite;
  }
};
</script>

<style scoped>
.v-btn {
  margin: 0;
}
</style>
